import { makeAutoObservable } from "mobx";
import { getEnv } from "mobx-easy";
import { RootEnv } from "stores/setup/create-store";
import { StoreState } from "../../../enum/StoreState";

export default class UserVerifyStore {
    state: string = StoreState.DONE;

    constructor() {
        makeAutoObservable(this);
    }

    reset() {
        this.state = StoreState.DONE;
    }

    setState(value: StoreState) {
        this.state = value;
    }

    async startPhoneVerification(to: string, channel: "sms" | "whatsapp" = "sms") {
        const { userVerifyService } = getEnv<RootEnv>();
        this.setState(StoreState.PEDDING);

        try {
            const response = await userVerifyService.startPhoneVerification(to, channel);

            this.setState(StoreState.DONE);
            return response;
        } catch (error) {
            console.error("Error fetching radar data: ", error);
        }
    }

    async checkPhoneVerification(to: string, code: string) {
        const { userVerifyService } = getEnv<RootEnv>();
        this.setState(StoreState.PEDDING);

        try {
            const response = await userVerifyService.checkPhoneVerification(to, code);

            this.setState(StoreState.DONE);
            return response;
        } catch (error) {
            console.error("Error fetching radar data: ", error);
        }
    }

}
